import {ISorter} from 'Common/helpers/Sorter/ISorter';

export const packageSorter: ISorter[] = [
  {order: 'asc', columnName: 'positionIndex', isNumber: true},
  {order: 'asc', columnName: 'name', isNumber: false},
];
